import { CHEATING_ACTIONS } from './constants';

export const getCheatingAction = (actions) =>
    actions?.find((action) => CHEATING_ACTIONS.includes(action.actionName));
